// extracted by mini-css-extract-plugin
export default {"container":"CardLayout_container__nKM5Q","content":"CardLayout_content__J3-N6","card":"CardLayout_card__khHv1","footer":"CardLayout_footer__8goXw","logo":"CardLayout_logo__1zWGk"};